/** In this file contains the landing page UI designs and functionality **/
import constantVariables from './../../dataset/constantVariables.json';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';

//Landing or Home page
export default function AboutNurture(){
	
	/** To check the token exist or not **/
   useEffect(()=>{
	  const section = document.getElementById("indexPage");
		if (section) {
		  section.scrollIntoView({ behavior: 'smooth' });
		}
   },[]);
   
	return (
	<> <div id="indexPage">
	{/**Breadcrumb Section**/}
	<section id="BreadcrumbSec" className="d-flex align-items-center justify-content-center">
		<div className="container">
			<div className="row d-flex">
				<div className="col-lg-12 align-items-center">
					<h1>{constantVariables.landing.aboutNurture}</h1>
				</div>
			</div>
		</div>
	</section>
	
	{/**About Section**/}
	<section className="section mb-5">
		<div className="container">
			<div className="row">  
				<div className="col-lg-5">  
					<div id="carouselAbout" className="carousel slide" data-bs-ride="carousel">
						<div className="carousel-inner">
							<div className="carousel-item active">
								<img src="/assets/img/web-about-img01.png" className="d-block w-100" alt="img" />
							</div>
							<div className="carousel-item">
								<img src="/assets/img/web-about-img02.png" className="d-block w-100" alt="img" />
							</div>
						</div>
					</div>
				</div> 
				<div className="col-lg-7 ps-lg-5">  
					<div className="sectionTitle">
						<h5>{constantVariables.landing.weAre}</h5>
						<h4>{constantVariables.landing.weAre1} <br/>{constantVariables.landing.weAre2}</h4>
					</div>
					<div className="sectionContent">
						<p>{constantVariables.landing.weAre1} <br/>{constantVariables.landing.weAre3}</p>
						
						<p>{constantVariables.landing.weAre1} <br/>{constantVariables.landing.weAre4}</p>
						
						<Link className="btn btn-tmBlue px-4 h4 mt-3">Get Started</Link>
					</div>
				</div>
			</div>
		</div>
	</section>
	</div></>);
}